import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/what-is-the-most-fire-resistant-roofing-material-knowing-whats-best.html")({
  beforeLoad: () => { throw redirect({ to: "/services", statusCode: 301 }); },
});
